import angular from 'angular';
import { AlternateSizesDialogComponent } from './alternate-sizes-dialog.component';
import AlternateSizesItem from '../../components/alternate-sizes-item';
export default angular
    .module('directives.alternateSizes', [
    AlternateSizesItem
])
    .component('alternateSizesDialog', AlternateSizesDialogComponent)
    .name;
//# sourceMappingURL=index.js.map